export default __webpack_public_path__ + "static/media/pictogramToAdd64.20da386a.svg";